import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        phone: null,
        LiqourOutlet:[],
        Other:[],
        offence:[],
        messages:[],
        processing:0,
        selected_outlet: null,
        selected_location: null,
        selected_ward : null,
        selected_district : null,
        selected_town : null,
        selected_location_types: null,
        report_liquor_outlet: false
    },
    mutations: {
        SET_LIQOUROUTLET:(state,LiqourOutlet) =>
        {
            state.LiqourOutlet = LiqourOutlet
        },
        SET_PHONE: (state,Phone)=>
        {
          state.phone =Phone
        },
        SET_OTHER: (state,Other) =>
        {
            state.Other = Other
        },
        SET_MESSAGES: (state, _messages) => {
            //console.log(JSON.stringify(_messages));
            state.messages = _messages;
        },
        SET_SELECTED_WARD: (state, _value) => {
            state.selected_ward = _value;
        },
        SET_SELECTED_LOCATION: (state, _value) => {
            state.selected_location = _value;
        },
        SET_SELECTED_DISTRICT: (state, _value) => {
            state.selected_district = _value;
        },
        SET_SELECTED_TOWN: (state, _value) => {
            state.selected_town = _value;
        },
        SET_SELECTED_LOCATION_TYPES: (state, _value) => {
            state.selected_location_types = _value;
        },
        SET_SELECTED_OFFENSES: (state, _value) => {
            state.offence = _value;
        },
        START_PROCESSING: (state) =>
        {
            state.processing++;
            /*console.log("Processing - Start: "+state.processing);*/
        },
        STOP_PROCESSING: (state) =>
        {
            if(state.processing > 0)
            {
                state.processing--;
            }
            /*console.log("Processing - Stop: "+state.processing);*/
        },
        SET_SELECTED_OUTLET: (state, _value) => {
            state.selected_outlet = _value;
        },

        SET_REPORT_LIQUOR_OUTLET: (state, _value) => {
            state.report_liquor_outlet = _value;
        },

    },
    getters:{
        CHECKBOX:()=>
        {

        }
    },
    actions: {
        SET_LIQOUROUTLET: ({commit}) =>
        {
            commit('SET_LIQOUROUTLET')
        },
        SET_OTHER: ({commit}) =>
        {
            commit(' SET_OTHER')
        },
        SET_PHONE:({commit}, _value) =>
        {
            commit('SET_PHONE',_value)
        },
        GET_MESSAGES:({commit},messages)=>
        {
            /*console.log("SET MESSAGES TO "+JSON.stringify(messages));*/
            commit('SET_MESSAGES',messages);
        },
        START_PROCESSING:({commit}) =>
        {
            commit('START_PROCESSING');
        },
        STOP_PROCESSING:({commit}) =>
        {
            commit('STOP_PROCESSING');
        },
        SET_REPORT_LIQUOR_OUTLET:({commit}, _value)=>
        {
            commit('SET_REPORT_LIQUOR_OUTLET',_value);
        },
        SET_SELECTED_WARD: ({commit}, _value)=>
        {
            commit('SET_SELECTED_WARD',_value);
        },
        SET_SELECTED_LOCATION: ({commit}, _value)=>
        {
            commit('SET_SELECTED_LOCATION',_value);
        },
        SET_SELECTED_DISTRICT: ({commit}, _value)=>
        {
            commit('SET_SELECTED_DISTRICT',_value);
        },
        SET_SELECTED_TOWN: ({commit}, _value)=>
        {
            commit('SET_SELECTED_TOWN',_value);
        },
        SET_SELECTED_LOCATION_TYPES: ({commit}, _value)=>
        {
            commit('SET_SELECTED_LOCATION_TYPES',_value);
        },
        SET_SELECTED_OUTLET: ({commit}, _value)=>
        {
            commit('SET_SELECTED_OUTLET',_value);
        },
        SET_SELECTED_OFFENSES: ({commit}, _value)=>
        {
            commit('SET_SELECTED_OFFENSES',_value);
        },
    },

});
